import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { displayDateAndTime } from "../../../../helper-functions";
import { useTIFFormData } from "../../../../hooks";
import PhotoThumbnail from "../../../photos/PhotoThumbnail";
import { AutoCol } from "../../../../component-library";
import { TissueInformationFormProps } from ".";

export function TIFPostProcedureGradingCairs({ tissueId }: Readonly<TissueInformationFormProps>) {
    const {
        tissue,
        fetchGradingCaseFileUrls,
        postProcedureEval,
        caseFileUrls,
        postProcessingFiles,
        postProcessingOverallRating,
    } = useTIFFormData({ tissueId });

    useEffect(() => {
        fetchGradingCaseFileUrls(postProcessingFiles);
    }, [fetchGradingCaseFileUrls, postProcessingFiles]);

    if (!tissue) {
        return <div>No tissue found</div>;
    }

    return (
        <Row>
            <Col>
                <div style={{ fontWeight: "bold" }}>POST-PROCESSING:</div>
                <div>CAIRS Tissue Number: {tissue?.number}</div>
                <div>Ring size: {postProcedureEval?.data?.graft?.ringSize} mm</div>
                <div>
                    Visible Epithelial/Endothelial Remains:{" "}
                    {postProcedureEval?.data?.graft?.visibleRemains ? "Yes" : "No"}
                </div>
                <div>Number of ring segments: {postProcedureEval?.data?.graft?.ringSegmentCount}</div>
                <div>Ring damage visible: {postProcedureEval?.data?.graft?.damageVisible ? "Yes" : "No"}</div>
                <div>
                    Post-Processing Overall Rating - <b>{postProcessingOverallRating}</b>
                </div>
                <div>
                    <span className="me-2">Name: {postProcedureEval?.signedByName}</span>
                    <span>Date/Time: {displayDateAndTime(postProcedureEval?.signedOn)}</span>
                </div>
            </Col>
            <AutoCol>
                {postProcessingFiles?.map((cf) => (
                    <PhotoThumbnail
                        key={cf.id}
                        caseFile={cf}
                        url={caseFileUrls[cf.id]}
                        maxHeight="110px"
                        maxWidth="110px"
                        className="m-0"
                    />
                ))}
            </AutoCol>
        </Row>
    );
}
